import ServiceRequest_QSet from './roleQuestionSets/ServiceRequest';
import FieldService_QSet from './roleQuestionSets/FieldService';
import ServiceParts_QSet from './roleQuestionSets/ServiceParts';
import ContractsWarranties_QSet from './roleQuestionSets/ContractsWarranties';
import ServiceMonetization_QSet from './roleQuestionSets/ServiceMonetization';
import None from './roleQuestionSets/ServiceParts';

const QuestionSets = {
    'Select your functional area': None,
    'Service Request Management': ServiceRequest_QSet,
    'Field Service': FieldService_QSet,
    'Service Parts Management': ServiceParts_QSet,
    'Contracts, Warranties & Subscriptions': ContractsWarranties_QSet,
    'Service Monetization': ServiceMonetization_QSet,
};       

export default QuestionSets;
